import { useApolloClient } from '@apollo/client';
import { getOperationName } from '@apollo/client/utilities';
import { GetJobsDocument } from '@shared/generated/graphql';
import { useCallback } from 'react';

// NOTE(wassim): Each add-in generates its own GetJobs document, so match by
// operation name instead of document identity.
const EMAIL_THREAD_JOBS_QUERY = getOperationName(GetJobsDocument) ?? 'GetJobs';

export function useRefetchEmailThreadJobs() {
  const apolloClient = useApolloClient();
  return useCallback(() => {
    apolloClient
      .refetchQueries({ include: [EMAIL_THREAD_JOBS_QUERY] })
      .catch(console.error);
  }, [apolloClient]);
}
